<template>
    <AppLayout>
      <template #header>
        <Navbar/>
      </template>
      <template #mainContent>
        <MainContent/>
      </template>
      <template #footerContent>
        <Footer/>
      </template>
    </AppLayout>
    <AutoLogout/>
  </template>
  
  <script>
  import AppLayout from "../components/Layout/DefaultLayout.vue";
  import Navbar from "../components/Layout/Navbar.vue";
  import Footer from "../components/Layout/Footer.vue";
  import AutoLogout from "../components/AutoLogout.vue";
  // Modificar o componente que será exibido
  import MainContent from "../components/Profile/StudentProfile.vue";
  
  export default {
    name: "Profile",
  
    components: {
      AppLayout,
      Navbar,
      Footer,
      AutoLogout,
      MainContent,
    },
  };
  </script>
  